import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import Audience from "../../create_mission_components/components/Audience";
import { PurpleMissionLiveRequirementsWarningModal } from "../../common_components/PurpleModals";


// Api Calls

function RequirementsPage(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    const [afterSavePath, setAfterSavePath] = useState(`/missions/${missionId}/`);

    //Mission is Live Modal
    const [warningModalIsOpen, setWarningModalIsOpen] = useState(false);
    const toggleModal = () => {
        setWarningModalIsOpen(!warningModalIsOpen);
    }

    useEffect(() => {
        const statusBackPath = props.missionStatus == "draft" ? `/createmission/${missionId}/audience` : `/missions/${missionId}`;
        setAfterSavePath(statusBackPath);
        if (props.missionStatus !== undefined && props.missionStatus != "draft") {
            setWarningModalIsOpen(true);
        }
    }, [props.missionStatus])

    return (
        <>
            <SubHeader title={"Audience Requirements"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <Audience nextPath={"/missions/" + missionId} nextText="Back" />
            </MissionPageContainer>
            <PurpleMissionLiveRequirementsWarningModal isOpen={warningModalIsOpen} toggleModal={toggleModal} onCancel={() => navigate(afterSavePath)} />
        </>

    )

}

export default RequirementsPage;